<template>
  <div class="mc-container">
    <p class="mc-titulo">MONITORAMENTOS CADASTRADOS</p>
    <table>
      <thead>
        <th>Nº Identificação</th>
        <th>Apelido</th>
        <th>Data do Cadastro</th>
        <th style="width: 200px">Filtros em Monitoramento</th>
        <th style="width: 200px">Valor Monitoramento</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in listaMonitorados" :key="index">
          <td>{{("0000000" + item.TermoMonitoramentoId).slice(-7)}}</td>
          <td>{{item.Termo}}</td>
          <td>{{formatacaoData(item.DataCriacao)}}</td>
          <td>
            <div class="filtro-monitoramento">
              <div>
                <strong>Termo:</strong> {{item.Termo}}
              </div>
              <div>
                <strong>Justiça:</strong> {{fomatarCampoExibicao(item.Justica)}}
              </div>
              <div>
                <strong>Partes:</strong> {{fomatarCampoExibicao(item.TiposParte)}}
              </div>
              <div>
                <strong>UF:</strong> {{fomatarCampoExibicao(item.UF).toUpperCase()}}
              </div>
            </div>
          </td>
          <td>{{formatarValor(item.ValorContrato)}}</td>
        </tr>

        <!-- <tr>
          <td>00006568</td>
          <td>Americanas</td>
          <td>03/07/2020</td>
          <td>
            <div class="filtro-monitoramento">
              <div>
                <strong>Termo:</strong> Lojas Americanas
              </div>
              <div>
                <strong>Justiça:</strong>Estadual; Federal; Trabalhista
              </div>
              <div>
                <strong>Partes:</strong> Réu; Autor
              </div>
              <div>
                <strong>UF:</strong> SP; SC; PE; BA
              </div>
            </div>
          </td>
          <td>R$ 400,00</td>
        </tr> -->
      </tbody>
    </table>
    <a
      href="#"
      style="display: flex; justify-content: flex-end; margin-top:10px"
    >Criar novo monitoramento</a>
  </div>
</template>
<script>
import alertaJuridicoApi from "../../api/consultAlertaJuridico.js";
export default {
  name:"MonitoramentoCadastrado",
  data() {
    return {
      listaMonitorados:[]
    }
  },
  mounted() {
    this.carregarMonitoramentoCadastrados()
  },
  methods: {
    carregarMonitoramentoCadastrados(){
      alertaJuridicoApi.buscarMonitoramentosCadastrados() .then((response) => {
          if (response.status == 200) {
            this.listaMonitorados = response.data.Content;
          }
        });
    },
    formatacaoData(data) {
      var d = new Date(data);
      return d.toLocaleDateString();
    },
    formatarValor(valor){
      return parseFloat(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    },
    fomatarCampoExibicao(string) {
      let stringSep = string.split(";")
      // console.log(stringSep)
      let stringFormatada = stringSep.reduce(
                (acc, cur) =>
                  acc + cur.charAt(0).toUpperCase() + cur.slice(1).toLowerCase()+ ", ",
                ""
              ).slice(0, -2)
        console.log(stringFormatada);
        return stringFormatada
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
/* *{
    border: 1px solid red;
} */
.mc-container {
  margin: 65px auto;
  max-width: 1000px;
  animation: fadeOut 0.3s;
}
@media screen and (max-width:700px) {
  .mc-container {
    padding: 30px;
  }
}
@keyframes fadeOut {
  from {
    opacity: 0;
    margin-top: 50px;
  }
  to {
    opacity: 1;
    /* margin-top: 17px; */
  }
}
.mc-titulo {
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 80px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
table,
th,
td {
  border: 1px solid #a8b2c0;
  text-align: center;
}
th {
  height: 32px;
  background-color: #1d375c;
  color: white;
  font-size: 0.9em;
}
td {
  /* height: 60px; */
}
td > .filtro-monitoramento {
  text-align: left;
  width: 200px;
  margin: 0 auto auto 40px;
}
</style>